import type { MailboxInfo } from "owa-client-types";
import { getAccountScopeUserSettings } from "../selectors/getAccountScopeUserSettings";
import type AttachmentPolicyType from "owa-service/lib/contract/AttachmentPolicyType";
import type RecursiveReadOnly from "owa-service/lib/RecursiveReadOnly";

export default function getAttachmentPolicy(mailboxInfo: MailboxInfo): RecursiveReadOnly<AttachmentPolicyType | undefined> {
    const userConfiguration = getAccountScopeUserSettings(mailboxInfo);
    return userConfiguration?.AttachmentPolicy;
}
